import { render, staticRenderFns } from "./TechRoute.vue?vue&type=template&id=fbb87744"
import script from "./TechRoute.vue?vue&type=script&lang=js"
export * from "./TechRoute.vue?vue&type=script&lang=js"
import style0 from "./TechRoute.vue?vue&type=style&index=0&id=fbb87744&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports